export const useErrorBoundary = ({
  errorStateName = 'loadingError',
  setterName = 'setLoadingError',
  defaultMsg = 'Sorry, something went wrong',
} = {}) => ({
  data: () => ({ [errorStateName]: { show: false, msg: '' } }),
  methods: {
    [setterName](e) {
      if (typeof e === 'boolean') {
        this[errorStateName] = { show: e, msg: defaultMsg };
      } else if (typeof e === 'string') {
        this[errorStateName] = { show: true, msg: e };
      } else if (e && typeof e === 'object') {
        this[errorStateName] = { show: true, msg: e.msg };
      }
    },
  },
});
